module.exports = __webpack_public_path__ + "static/media/Carolina_Hurricanes.89b1205d.svg";